import { NgModule } from '@angular/core';
import { PlaceOrderSchoolComponent } from './school.component';
import { PlaceOrderModule } from '@schoolbelle/shared/components';

@NgModule({
  declarations: [PlaceOrderSchoolComponent],
  imports: [
    PlaceOrderModule,
  ],
  exports : [PlaceOrderSchoolComponent],

})
export class PlaceOrderSchoolModule { }
